/**
 * @Author: AI Assistant
 * @Date: 2025-07-02 15:42:00
 * @Description: 数据字典路由配置
 */

const MenuLayout = () => import('@/components/layout/index.vue')
const Layout = () => import('@/views/index/index.vue')
// 备份服务页面
const BackupService = () => import('@/views/backup-service/index.vue')
export default // 应用管理
// 基础服务页面
{
  path: '/backup',
  // component: layout,
  // component: import('@/views/index/index.vue'),
  component: Layout,
  // 重定向
  children: [
    // 应用管理
    {
      path: 'service',
      name: 'backup',
      // component: import('@/components/layout/index.vue'),
      component: MenuLayout,
      children: [
        {
          path: 'index',
          name: 'backupIndex',
          component: BackupService,
          meta: {
            name: '备份服务',
            context: 'backup/service/index',
            type: 'INNER_APP'
          }
        }
      ]
    }
  ]
}
